<template>
  <div class="page">
    <div class="searchBox">
      <el-form>
        <el-row>
          <!-- <el-col :span="4">
            <el-form-item>
              <el-input style="width:130px;margin-right: 10px;" placeholder="负责人名字" v-model="search.keyword" clearable
                @keyup.enter.native="changeSearch" size="small"></el-input>
              <el-button @click="changeSearch" type="warning" size="small">搜索</el-button>
            </el-form-item>
          </el-col> -->
          <el-col :span="4">
            <el-form-item label="门店">
              <el-select style="width: 140px" size="small" class="select" v-model="shopId" placeholder="请选择"
                @change="changeSearch">
                <el-option v-for="item in shopList" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="日期" :label-width="'40px'">
              <el-date-picker v-model="month" type="month" placeholder="选择月" value-format="yyyyMM" @change="mont(month)">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="负责类型" :label-width="'90px'">
              <el-select style="width:100px;" class="select" v-model="serviceType" @change="changeSearch"
                placeholder="请选择" size="small">
                <el-option
                  v-for="item in [{ label: '全部', value: '' }, { label: '医助', value: '1' }, { label: '饲养员/销售', value: '2' }, { label: '洗美', value: '3' }, { label: '医生', value: '4' }]"
                  :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="5" style="display: flex;">
            <resetBtn @reset="reset"></resetBtn>
          </el-col>
          <el-button type="warning"  v-if="$buttonAuthority('huoti-charge-derive')" size="small" style="float: right;" @click="handelexportClick">数据导出</el-button>
        </el-row>
      </el-form>
    </div>
    <div class="pageConBox">
      <el-table class="table" :data="tableData" style="width: 100%">
        <el-table-column prop="staffName" label="负责人姓名" width="140"></el-table-column>
        <el-table-column prop="shopName" label="门店" width="140"></el-table-column>
        <el-table-column prop="serviceType" label="负责类型">
        </el-table-column>
        <el-table-column prop="saleCount" label="已售"></el-table-column>
        <el-table-column label="服务总只数" width="130" prop="serviceTotalCount">
        </el-table-column>
        <el-table-column prop="deathCount" label="当月死亡"></el-table-column>
        <el-table-column label="详情" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="see(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>

      <page :total="page.total" :pageSize="page.pageSize" :page="page.page" @change="changePage" style="padding-bottom: 10px;"></page>
    </div>
    <el-dialog title="我负责的宠物" :modal-append-to-body="false" :visible.sync="dialogconfirm_state" width="50%">
      <div class="pageConBox">
        <el-table class="table" :data="tableDetail">
          <el-table-column prop="petName" label="活体名称" width="140"></el-table-column>
          <el-table-column prop="epromNo" label="活体芯片号" width="140"></el-table-column>
          <el-table-column prop="status" label="销售状态">
          </el-table-column>
          <el-table-column prop="startTime" label="负责开始时间"></el-table-column>
          <el-table-column label="负责结束时间" width="130" prop="endTime">
            <template slot-scope="scope">
              {{ scope.row.endTime ? scope.row.endTime : '--' }}
            </template>
          </el-table-column>
        </el-table>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import resetBtn from "../../components/resetBtn.vue";
import page from "@/components/page.vue"
import axios from 'axios';
export default {
  components: { resetBtn, page },
  data() {
    return {
      search: {
        staffId: ''
      },
      page: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      shopList: this.$store.state.myShopList,
            shopId: "",
      dialogconfirm_state: false,
      month: '',
      serviceType: '',
      tableData: [],
      petCategoryId: '',
      tableDetail: []
    }
  },
  mounted() {
    var date = new Date;
    var year = date.getFullYear();
    this.month = date.getMonth() + 1;
    this.month = (this.month < 10 ? "0" + this.month : this.month);
    this.month = (year.toString() + this.month.toString());
    this.getTableData();
  },
  methods: {
    mont(month) {
      console.log(month);
      this.changeSearch()
    },
    see(row) {
      let params = {
        pageIndex: 1,
        pageSize: 1000,
        staffId: row.staffId,
        shopId: row.shopId,
        month: this.month,
        petCategoryId: this.petCategoryId
      }
      if (row.serviceType == '洗美') {
        params.serviceType = '3'
      }
      if (row.serviceType == '医助') {
        params.serviceType = '1'
      }
      if (row.serviceType == '饲养') {
        params.serviceType = '2'
      }
      if (row.serviceType == '医生') {
        params.serviceType = '4'
      }
      let loading = this.$loading();
      this.$http
        .post(
          process.env.VUE_APP_Url_8000 + "/api/staff/service/pet/detail/page/list",
          params
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.tableDetail = res.data.list;
            this.page.total = res.data.count;
          }
        })

      this.dialogconfirm_state = true
    },
    confirmSort() {
      this.dialogconfirm_state = false
    },
    getTableData() {
      let params = {
        pageIndex: this.page.page,
        pageSize: this.page.pageSize,
        staffId: this.search.staffId,
        shopId: this.shopId,
        month: this.month,
        serviceType: this.serviceType
      }
      let loading = this.$loading();
      this.$http
        .post(
          process.env.VUE_APP_Url_8000 + "/api/staff/service/pet/summary/page/list",
          params
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            console.log('负责列表', res)
            this.tableData = res.data.list;
            this.page.total = res.data.count;
          }
        })
    },
    // 下载预警列表
    handelexportClick() {
      let loading = this.$loading();
      axios.get(process.env.VUE_APP_Url_8000 + '/api/staff/service/pet/summary/list/export', {
        params: {
          month: this.month,
          shopId:this.shopId,
          serviceType:this.serviceType,
        },
        responseType: 'blob',
      }).then(response => {
        console.log("导出", response);
        var href = window.URL.createObjectURL(response.data); //创建下载的链接
        var downloadElement = document.createElement('a');
        downloadElement.href = href;
        downloadElement.download = '负责宠物导出表.xlsx';
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
        loading.close();
      }).catch(err => {
        console.log(err)
      })
    },

    // 改变分页
    changePage(num) {
      this.page.page = num;
      this.getTableData();
    },
    changeSearch() {
      this.page.page = 1;
      this.getTableData()
    },
    // 重置筛选
    reset() {
      this.page.page = 1;
      // this.search.starttime = '';
      // this.search.endtime = '';
      // this.datetimerange = [];
      // this.search.state = -1;
      // this.search.pay_type = -1;
      // this.search.return_type = -1;
      // this.search.source = -1;
      this.getTableData();
    }
  }
}
</script>

<style scoped lang="scss">
.page {
  .searchView {
    .tabLine {
      display: flex;

      .tabItem {
        width: 88px;
        box-sizing: border-box;
        line-height: 36px;
        text-align: center;
        border-right: 1px solid #f2f2f2;
        cursor: pointer;
        font-size: 14px;
        background-color: #fff;

        &.active {
          color: $mainColor;
        }
      }
    }

    .searchBox {
      border-top: 1px solid #f2f2f2;
    }
  }

  .content {
    padding: 0 0px;
    min-height: 600px;

    ::v-deep .el-form-item {
      margin-bottom: 0;

      .el-form-item__label {
        padding-right: 5px;
        font-size: 12px;
      }
    }
  }
}
</style>